import { LeftOutlined, LogoutOutlined } from '@ant-design/icons';
import { useKeycloak } from '@react-keycloak/web';
import { Button, List } from 'antd';
import { FC, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LoggedInUserContext } from '../../context/loggedInUser';
import { useIsTenantAdmin } from '../../hooks/useIsTenantAdmin';
import theme from '../../styles/theme';
import { getTenant } from '../../utils/getKeycloakConfig';
import {
  BackButton,
  Company,
  Name,
  PageTitle,
  StyledDrawer,
  StyledHeader,
  StyledListItem,
  UserAvatar,
  UserInfo,
  Username,
} from './style';

interface Props {
  pageTitle?: string;
}

const Header: FC<Props> = props => {
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const isTenantAdmin = useIsTenantAdmin();
  const loggedInUser = useContext<any>(LoggedInUserContext);
  const { pageTitle } = props;
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const firstName = loggedInUser.given_name ?? loggedInUser.firstName;
  const lastName = loggedInUser.family_name ?? loggedInUser.lastName;

  const getUserInitials = () => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    } else {
      return '';
    }
  };

  const logout = () => {
    localStorage.removeItem('kc');
    keycloak.logout();
  };

  return (
    <StyledHeader $admin={isTenantAdmin} data-testid="header">
      {pageTitle && (
        <PageTitle>
          <BackButton
            data-testid="go-back"
            onClick={() => history.goBack()}
            icon={<LeftOutlined />}
            shape="circle"
            className="wx-auto"
          />
          {pageTitle}
        </PageTitle>
      )}

      <Button
        type="text"
        data-testid="toggle-header-drawer"
        icon={
          <UserAvatar style={{ backgroundColor: theme.palette.primary.main }}>
            {getUserInitials()}
          </UserAvatar>
        }
        shape="circle"
        onClick={() => setIsDrawerVisible(!isDrawerVisible)}
        style={{ marginLeft: 'auto', border: 'none' }}
        className="wx-auto p-0 h-32 w-32"
      />

      <StyledDrawer
        data-testid="header-drawer"
        title={
          <UserInfo>
            <div>
              <UserAvatar
                style={{ backgroundColor: theme.palette.text.primary }}
                size="large"
              >
                {getUserInitials()}
              </UserAvatar>
            </div>
            <Name>
              {firstName} {lastName}
              <Username>
                {loggedInUser.preferred_username ?? loggedInUser.username}
              </Username>
              <Company>{getTenant()}</Company>
            </Name>
          </UserInfo>
        }
        placement="right"
        closable={false}
        onClose={() => setIsDrawerVisible(false)}
        visible={isDrawerVisible}
      >
        <List size="small">
          <StyledListItem data-testid="logout" onClick={logout}>
            <LogoutOutlined /> Log Out
          </StyledListItem>
        </List>
      </StyledDrawer>
    </StyledHeader>
  );
};

export default Header;
